import { render, staticRenderFns } from "./BenefitCatalogs.vue?vue&type=template&id=6d9861bb&scoped=true"
import script from "./BenefitCatalogs.vue?vue&type=script&lang=js"
export * from "./BenefitCatalogs.vue?vue&type=script&lang=js"
import style0 from "./BenefitCatalogs.vue?vue&type=style&index=0&id=6d9861bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9861bb",
  null
  
)

export default component.exports